import { Alert, AlertContent, AlertDescription, AlertTitle } from '../../../Alert';
import type { SingleNotificationProps } from './SingleNotification.types';

export const SingleNotification = ({ title, message, onDismiss, ...otherProps }: SingleNotificationProps) => (
  <Alert corner="rounded" closeable onClose={onDismiss} {...otherProps}>
    <AlertContent>
      {title && <AlertTitle>{title}</AlertTitle>}
      {message && <AlertDescription>{message}</AlertDescription>}
    </AlertContent>
  </Alert>
);
